import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import "./BlogDetailsPage.css";
const GOOGLE_SHEET_API_URL = "https://script.google.com/macros/s/AKfycbzNePVdb8kwFqV381MKbgR7I5GZKH5Gg9nF_ypfCgizYYMouNsMpWa8eku_MuVcqWIJgA/exec";
export default function BlogDetailPage() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  useEffect(() => {
    fetch(GOOGLE_SHEET_API_URL)
      .then((res) => res.json())
      .then((data) => {
        const foundBlog = data.find((b) => String(b.id) === String(id));
        setBlog(foundBlog);
      })
      .catch((err) => console.error("Error fetching blog detail:", err));
  }, [id]);
  if (!blog) {
    return <p className="blog-loading">Loading blog...</p>;
  }
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

  return (
    <article className="blog-detail">
        <h1 className="blog-detail-title">{blog.title}</h1>
        <h3 style={{fontWeight:"400"}}>{blog.short_description}</h3>
      <p className="blog-detail-meta">
        {blog.author} • {blog.date}
      </p>
      <img src={blog.image_url} alt={blog.title} className="blog-detail-image" />
      <div className="blog-detail-body">{blog.intro}
            <h1>{blog.list_items_title}</h1>
            <p>{blog.list_items}</p>
            <h1>{blog.paragraph_title}</h1>
            <p>{blog.paragraph}</p>
            <img src={blog.gallery_images} alt={blog.title} className="blog-detail-image" />
            <h4>{blog.conclusion}</h4>
            </div>
      <Link
  to="/blogs"
  className="blog-back-btn"
  onClick={() => window.scrollTo(0, 0)}>
  ← Back to Blogs
</Link>
    </article>
  );
}